module.exports = __webpack_public_path__ + "img/data_sisa_cuti.e457eb8a.png";